// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"408":"beeec03ee9c7dd95","943":"40e00d6d3b9dbcb5"}[chunkId] + ".js";
};